import { useKeywords } from './useKeywords'

export const useKeywordByUrlId = (keywordUrlId = null, swrOptions) => {
  const { data: keywords, ...rest } = useKeywords(
    () => (keywordUrlId ? { urlId: keywordUrlId } : null),
    swrOptions
  )
  return { data: keywords?.[0], ...rest }
}
